<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<ng-container>
  <div class="account-type-card">
    <span [ngStyle]="{'background-color': color}"
          class="top-icon">
      <i class="large-icon" [ngClass]="iconClass"></i>
    </span>

    <div class="mt p d-flex flex-column">
      <h4 class="title d-flex justify-center">{{ title | uppercase }}</h4>
      <p class="mt d-flex justify-center description" style="color: #525252">{{ description }}</p>
      <div class="d-flex justify-center mt-xl">
        <button pButton
                label="{{'signup.utils.choose' | translate}}"
                class="p-button-outlined"
                style="width: 40%"
                (click)="goToNextStep()" data-testid="go-to-next-step-btn"></button>
      </div>
    </div>

  </div>
</ng-container>


